export default {"src":"/_next/static/media/holo.e4ab349a.svg","height":17,"width":153};